var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#717171"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65444 6.625C7.83423 5.49151 8.81592 4.625 10 4.625H13C14.3117 4.625 15.375 5.68832 15.375 7V11C15.375 12.3117 14.3117 13.375 13 13.375H12.3456C12.1658 14.5085 11.1841 15.375 10 15.375H7C5.68832 15.375 4.625 14.3117 4.625 13V9C4.625 7.68832 5.68832 6.625 7 6.625H7.65444ZM8.41848 6.625H10C11.3117 6.625 12.375 7.68832 12.375 9V12.625H13C13.8975 12.625 14.625 11.8975 14.625 11V7C14.625 6.10254 13.8975 5.375 13 5.375H10C9.23161 5.375 8.58777 5.90833 8.41848 6.625ZM7 7.375C6.10254 7.375 5.375 8.10254 5.375 9V13C5.375 13.8975 6.10254 14.625 7 14.625H10C10.8975 14.625 11.625 13.8975 11.625 13V9C11.625 8.10254 10.8975 7.375 10 7.375H7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.bb7ba6d4337f2c73686b32d0623e3012.svg";
export { ForwardRef as ReactComponent };